//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ["value", "label", "toolTip", "horizontal"],
  data: function data() {
    return {};
  },
  methods: {}
};